import { makeStyles, Typography } from '@material-ui/core';
import { } from '@material-ui/styles';
import React, { CSSProperties } from 'react';

const useStyles = makeStyles((theme) => ({
    subHeader: {
        display: 'flex',
        margin: '30px 3px 12px 3px',
    },
    subHeaderText: {
        fontFamily: 'Gellix',
        fontWeight: 500,
        color: theme.palette.primary.main,
        opacity: '0.8',
        textTransform: 'uppercase',
        letterSpacing: '1px',
        fontSize: '16px',
    },
    halfCircle: {
        backgroundColor: theme.palette.primary.main,
        height: '20px',
        width: '10px',
        borderTopRightRadius: '20px',
        borderBottomRightRadius: '20px',
        margin: 'auto 16px auto 0',
    },
}));

interface AppSubHeaderProps {
    name: string;
    style?: CSSProperties;
}

const AppSubHeader = ({ name, style }: AppSubHeaderProps) => {
    const classes = useStyles();

    return (
        <div className={classes.subHeader}>
            <div className={classes.halfCircle}></div>
            <Typography variant='h6' className={classes.subHeaderText} style={style}>
                {name}
            </Typography>
        </div>
    );
};

export default AppSubHeader;
